import { PrinterType } from "../models/settings-printers.model";

export const DEFAULT_CONFIGS: Record<PrinterType, any> = {
  nonfiscal: {
    add_prices_to_order: false,
    codepage_mapping: 'epson',
    footer_printer_categories: -1,
    footer_order_number: -1,
    footer_operator_name: -1,
    footer_print_type: -1,
    footer_date: -1,
    footer_time: -1,
    footer_room_name: -1,
    footer_table_name: -1,
    footer_covers: -1,
    footer_delivery_info: -1,
    footer_order_name: -1,
    footer_customer_info: -1,
    footer_order_notes: -1,
    footer_total_pieces: -1,
    footer_final_amount: -1,
    header_printer_categories: -1,
    header_order_number: 16,
    header_operator_name: 16,
    header_print_type: 16,
    header_date: 16,
    header_time: 16,
    header_room_name: 16,
    header_table_name: 16,
    header_covers: 16,
    header_delivery_info: 16,
    header_order_name: 0,
    header_customer_info: 16,
    header_order_notes: 0,
    header_total_pieces: -1,
    header_final_amount: -1,
    item_font_size: 16,
    item_spacing: 1,
    item_hide_border: false,
    item_hide_brackets: false,
    items_align: 'center',
    items_group_by: 'exit',
    other_printers_font_size: 0,
    line_spacing: 80,
    split_orders_by_exit: false,
    variation_font_size: 16,
  },
  receipt: {
    split_stubs_by_category: false,
    print_other_categories: false,
    codepage_mapping: 'epson'
  },
  fiscal: {
    split_stubs_by_category: false,
    print_other_categories: false,
  },
  rt: {
    split_stubs_by_category: false,
    print_other_categories: false,
  },
  kds: {}
}